import { useCallback } from 'react';
import { useParams } from 'react-router';
import { EmployeeService } from 'src/api/EmployeeService';
import type { Employee } from 'src/api/EmployeeService';
import { invalidateEmployee, invalidateEmployees } from '@stores/employeeStore';

type PatchEmployee = (
    employeeId: string,
    patch: Partial<Employee>,
) => Promise<Employee | undefined>;

const usePatchEmployee = (): { patchEmployee: PatchEmployee } => {
    const { departmentId } = useParams<{
        departmentId: string;
    }>();

    const patchEmployee = useCallback<PatchEmployee>(
        async (employeeId, patch) => {
            if (!departmentId) {
                throw new Error(
                    'usePatchEmployee requires a departmentId route param',
                );
            }

            const updatedEmployee = await EmployeeService.patchEmployee(
                departmentId,
                employeeId,
                patch,
            );

            if (!updatedEmployee) {
                return undefined;
            }

            invalidateEmployee(departmentId, employeeId);
            invalidateEmployees(departmentId);

            return updatedEmployee;
        },
        [departmentId],
    );

    return { patchEmployee };
};

export default usePatchEmployee;
